import Utils from 'src/utils';
import { RewardsActions } from 'src/store/actions/rewardActions';
import { toDropDownSelectorOptions } from 'src/components/Inputs/DropDownSelector/instruments';
const initialState = {
    typesList: [],
    typesOptions: [],
    typesLoading: false,
    registry: {},
    registryLoading: false,
    personRewards: {},
    personRewardsLoading: false,
    reportData: {},
    reportGrandTotals: [],
    reportLoading: false,
    timeTableRewardsColumns: [],
    timeTableRewardsMap: {},
    timeTableRewardsLoading: false
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case RewardsActions.GET_REWARD_TYPES_REQUEST:
        case RewardsActions.DELETE_REWARD_TYPE_REQUEST:
        case RewardsActions.POST_REWARD_TYPE_REQUEST: {
            return {
                ...state,
                typesLoading: true
            };
        }
        case RewardsActions.GET_REWARD_TYPES_SUCCESS: {
            return {
                ...state,
                typesList: payload,
                typesOptions: toDropDownSelectorOptions(payload),
                typesLoading: false
            };
        }
        case RewardsActions.DELETE_REWARD_TYPE_SUCCESS: {
            const updatedTypes = state.typesList.filter((item) => item.Id !== payload);
            return {
                ...state,
                typesList: updatedTypes,
                typesOptions: toDropDownSelectorOptions(updatedTypes),
                typesLoading: false
            };
        }
        case RewardsActions.POST_REWARD_TYPE_SUCCESS: {
            const updatedTypes = Utils.arrays.mergeWithNestedObjectsReplace(state.typesList, [payload], 'Id');
            return {
                ...state,
                typesList: updatedTypes,
                typesOptions: toDropDownSelectorOptions(updatedTypes),
                typesLoading: false
            };
        }
        case RewardsActions.GET_REWARD_TYPES_FAIL:
        case RewardsActions.DELETE_REWARD_TYPE_FAIL:
        case RewardsActions.POST_REWARD_TYPE_FAIL: {
            return {
                ...state,
                typesLoading: false
            };
        }
        case RewardsActions.GET_REWARD_REGISTRY_REQUEST:
        case RewardsActions.POST_REWARD_REGISTRY_ITEM_REQUEST:
        case RewardsActions.DELETE_REWARD_REGISTRY_ITEM_REQUEST: {
            return {
                ...state,
                registryLoading: true
            };
        }
        case RewardsActions.GET_REWARD_REGISTRY_SUCCESS: {
            return {
                ...state,
                registry: payload,
                registryLoading: false
            };
        }
        case RewardsActions.POST_REWARD_REGISTRY_ITEM_SUCCESS: {
            if (!state.registry.Data) {
                return {
                    ...state,
                    registryLoading: false
                };
            }
            const updatedRegistry = Utils.arrays.mergeWithNestedObjectsReplace(state.registry.Data, [payload], 'Id');
            return {
                ...state,
                registry: {
                    ...state.registry,
                    Data: updatedRegistry
                },
                registryLoading: false
            };
        }
        case RewardsActions.DELETE_REWARD_REGISTRY_ITEM_SUCCESS: {
            return {
                ...state,
                registry: {
                    ...state.registry,
                    Data: state.registry.Data?.filter((item) => item.Id !== payload)
                },
                registryLoading: false
            };
        }
        case RewardsActions.GET_REWARD_REPORT_REQUEST: {
            return {
                ...state,
                reportLoading: true
            };
        }
        case RewardsActions.GET_REWARD_REPORT_SUCCESS: {
            return {
                ...state,
                reportData: payload.departments,
                reportGrandTotals: payload.totals,
                reportLoading: false
            };
        }
        case RewardsActions.GET_REWARD_REGISTRY_FAIL:
            return {
                ...state,
                registryLoading: false
            };
        case RewardsActions.GET_PERSON_REWARDS_REQUEST:
            return {
                ...state,
                personRewardsLoading: true
            };
        case RewardsActions.GET_PERSON_REWARDS_SUCCESS:
            return {
                ...state,
                personRewards: {
                    ...state.personRewards,
                    ...payload
                },
                personRewardsLoading: false
            };
        case RewardsActions.GET_PERSON_REWARDS_FAIL:
            return {
                ...state,
                personRewardsLoading: false
            };
        case RewardsActions.POST_PERSON_REWARD_SUCCESS:
            return {
                ...state,
                personRewards: {
                    ...state.personRewards,
                    [payload.PersonId]: [
                        ...(state.personRewards[payload.PersonId] || []),
                        payload
                    ]
                }
            };
        case RewardsActions.UPDATE_PERSON_REWARD_SUCCESS:
            return {
                ...state,
                personRewards: {
                    ...state.personRewards,
                    [payload.PersonId]: state.personRewards[payload.PersonId].map((item) => {
                        if (item.Id === payload.Id) {
                            return payload;
                        }
                        return item;
                    })
                }
            };
        case RewardsActions.DELETE_PERSON_REWARD_SUCCESS:
            return {
                ...state,
                personRewards: {
                    ...state.personRewards,
                    [payload.personId]: state.personRewards[payload.personId].filter((item) => item.Id !== payload.id)
                }
            };
        case RewardsActions.GET_TIMETABLE_REWARDS_REQUEST:
            return {
                ...state,
                timeTableRewardsLoading: true
            };
        case RewardsActions.GET_TIMETABLE_REWARDS_SUCCESS:
            return {
                ...state,
                timeTableRewardsColumns: payload.columns,
                timeTableRewardsMap: payload.personsMap,
                timeTableRewardsLoading: false
            };
        case RewardsActions.GET_TIMETABLE_REWARDS_FAIL:
            return {
                ...state,
                timeTableRewardsLoading: false
            };
        default: return state;
    }
};
